import { render } from "./product.vue?vue&type=template&id=44c93384&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"

import "./product.vue?vue&type=style&index=0&id=44c93384&lang=less&scoped=true"

import exportComponent from "E:\\ekt.pro.git\\new-ekt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c93384"]])

export default __exports__